import { createContext, useContext } from "react";
const IndexTableContext = createContext({});
const useIndexTableDisabled = (props) => {
  const disabledFromProps = props.disabled;
  const context = useContext(IndexTableContext);
  return disabledFromProps || (context == null ? void 0 : context.disabled);
};
export {
  IndexTableContext,
  useIndexTableDisabled
};
